<template>
    <section class="member-signup" v-if="this.culture === 'en'">

    <div class="row">

        <div class="col-xs-12">

            <div class="field-wrapper half">
                <label>{{ d.languagedetailslabel }}*</label>
                <div class="list-inline">
                    <label class="radio">
                        <input type="radio" name="information-language-selection" required="true" v-model="values.informationLanguage" @change="onRadioLanguageChange" value="english">
                        <span class="checklabel">{{ d.languagedetailsenglish }}</span>
                        <span class="checkmark"></span>
                    </label>

                    <label class="radio">
                        <input type="radio" name="information-language-selection" required="true" v-model="values.informationLanguage" @change="onRadioLanguageChange" value="danish">
                        <span class="checklabel">{{ d.languagedetailsdanish }}</span>
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>

            <div class="input-errors" v-for="error of v$.values.informationLanguage.$errors" :key="error.$uid">
                <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorinformation }}</div>
            </div>
        </div>

    </div>

    </section>

</template>


<script>
import useVuelidate from '@vuelidate/core'

export default {
    data: (instance) => {
      return {
        values: instance.store[instance.store.currentCulture].values.personalDetails,
        d: instance.store[instance.store.currentCulture].dictionary,
        culture: instance.store.currentCulture,
      }
    },
    setup () {
      // we use vuelidate for validation 
      // https://vuelidate-next.netlify.app/
      return { v$: useVuelidate({$lazy:true}) }
    },
    watch: {

    },
    mounted() {
        this.emitter.on('culture-change', () => {
            this.values = this.store[this.store.currentCulture].values.personalDetails;
            this.d = this.store[this.store.currentCulture].dictionary;
            this.culture = this.store.currentCulture;
            this.v$.$reset()
        });
    },
    validations() {
      return this.validations.languageDetails;
    }
}
</script>


<style scoped lang="postcss">

</style>